<template>
  <div class="header">
      <!-- <h3>{{headertxt}}</h3> -->
          <header  id="header" class="sticky-top">
       <div class="container-fluid" >
          <nav  type="dark" variant="info" align-v="center" class="height100 navbar">            
                          <div class="navbar-brand" >
                  <div class="logo">
                        <a  :href="homePageURL">
                           <img src="../assets/images/logo-genamet.png" width="190px" height="auto">                           
                        </a>
                  </div>
               </div>
               <nav class="navbar-collapse collapse">
        <ul class="navbar-nav navbar-nav-left header-links d-none d-md-flex">
        <li class="nav-item" >
            <a :href="homePageURL" class="nav-link">  Home  </a>
          </li>
          <li class="nav-item active" >
            <a :href="aboutUsURL" class="nav-link"> About  </a>
          </li>
          <li class="nav-item">
            <a :href="servicesURL" class="nav-link">Services </a>
          </li>		  
          <li class="nav-item">
            <a :href="pricingURL" class="nav-link">Pricing</a>
          </li>
           <li class="nav-item">
            <a href="#ourteam" class="nav-link">Our team</a>
          </li>
           <li class="nav-item">
            <a :href="contactUsURL" class="nav-link">Contact</a>
          </li>
		
        </ul>

        <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
          <span class="mdi mdi-menu"></span>
        </button>
    </nav>
          </nav>
       </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'Header',
   data: function() {
    return {
      homePageURL: process.env.VUE_APP_HOME_REDIRECT_URL,
      aboutUsURL: process.env.VUE_APP_ABOUT_US_REDIRECT_URL,
      pricingURL: process.env.VUE_APP_PRICING_REDIRECT_URL,
      servicesURL: process.env.VUE_APP_SERVICES_REDIRECT_URL,
      contactUsURL: process.env.VUE_APP_CONTACT_US_REDIRECT_URL,
    };
  },
  props: {
    headertxt: String
  }
}
</script>